/**
 * Created by hp on 2017/6/2.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

import '../styles/NetworkDelay.css';

class NetworkDelay extends Component {
    renderDelay(){
        const {chatroom} = this.props;
        if(chatroom.status === 'offline')
            return <p className="bad">网络已断开</p>

        let netWorkClass = 'good';
        let netWorkLabel = '网络良好';
        if ( chatroom.networkDelay > 100 && chatroom.networkDelay < 200) {
            netWorkClass = 'warning';
            netWorkLabel = '网络一般';
        } else if (chatroom.networkDelay >= 300) {
            netWorkClass = 'bad';
            netWorkLabel = '网络很差';
        }
        return <p className={netWorkClass}>{netWorkLabel}：{chatroom.networkDelay}ms</p>
    }

    render() {
        return(
            <div className="networkDelay">
                {this.renderDelay()}
            </div>
        );
    }
}


export default connect(state => ({
    chatroom: state.chatroom,
}))(NetworkDelay)


// WEBPACK FOOTER //
// ./src/components/NetworkDelay.js